import { render, staticRenderFns } from "./VaccineListFromProducts.vue?vue&type=template&id=0422f3f4"
import script from "./VaccineListFromProducts.vue?vue&type=script&lang=js"
export * from "./VaccineListFromProducts.vue?vue&type=script&lang=js"
import style0 from "./VaccineListFromProducts.vue?vue&type=style&index=0&id=0422f3f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports